import axios from "@/common/axios"
import api from "@/common/api/api"

function firstQueryValue(value) {
	return Array.isArray(value) ? value[0] : value
}

export function requestWebSimpleLoginCode(route, data) {
	const params = {
		app_key: firstQueryValue(route.query.app_key),
		response_type: firstQueryValue(route.query.response_type) || "code",
		state: firstQueryValue(route.query.state),
		scope: firstQueryValue(route.query.scope),
		terminal: firstQueryValue(route.query.terminal) || "PC",
	}

	return axios.post(api.webSimpleLoginCode, data, { params })
}
